// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"C9btmpKqYElu","disabled":"tpaMfhdNQjQ5"};